import { InjectionToken } from '@angular/core';
import { LogLevel } from '../logger';

export const TRANSPORTER_CONFIG = new InjectionToken<TransporterConfig>('TransporterConfig');

export interface TransporterConfig {
  level?: LogLevel;
  debugActions?: { [key: string]: LogLevel };
}
